import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { System } from '@app/core/resources/system';
import { getSystemDisplayName } from '@app/core/helpers/system-display-name.helper';
import { GetLandingSystemUseCase } from 'common/landing-for-systems/application/use-cases/get-landing-system.use-case';
import { catchError, map, Observable, of } from 'rxjs';

export const resolveBuySellSeoSystemName: ResolveFn<string> = (route): Observable<string> => {
    const systemId: string = route.paramMap.get('system') ?? '';
    if (!systemId) {
        return of('');
    }

    return inject(GetLandingSystemUseCase)
        .execute({ systemId, mode: 'base' })
        .pipe(
            map((system: System): string => getSystemDisplayName(system, '')),
            catchError((): Observable<string> => of('')),
        );
};
